import React, { useState } from 'react'
import { Button, Checkbox, Dialog, Progress, Typography } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { StyledLink } from '@/components/styles/AboutStyles'

const SHAREPOINT_URL =
    'https://statoilsrm.sharepoint.com/sites/DigitalFieldWorkerHUB/SitePages/nb/New-app--Trending.aspx'

interface TrendingConsentDialogProps {
    isBusy?: boolean
    onCancel: () => void
    onConfirm: (dontShowAgain: boolean) => void
}

const TrendingConsentDialog: React.FC<TrendingConsentDialogProps> = ({ isBusy, onCancel, onConfirm }) => {
    const [dontShowAgain, setDontShowAgain] = useState(false)

    return (
        <StyledDialog open onClose={onCancel}>
            <Dialog.Header>
                <Dialog.Title>Trending</Dialog.Title>
            </Dialog.Header>
            <Dialog.CustomContent>
                <Typography variant="body_short">
                    The IIoT Team is not responsible for the Trending App. Errors or support is not handled by us. Visit
                    Trending App{' '}
                    <StyledLink href={SHAREPOINT_URL} target="_blank" rel="noopener noreferrer">
                        Sharepoint
                    </StyledLink>{' '}
                    for more information.
                </Typography>
                <CheckboxContainer>
                    <Checkbox
                        label="Don't show this again"
                        checked={dontShowAgain}
                        onChange={(e) => setDontShowAgain(e.target.checked)}
                    />
                </CheckboxContainer>
            </Dialog.CustomContent>
            <Dialog.Actions style={{ justifySelf: 'end' }}>
                <ActionsContainer>
                    <Button variant="outlined" onClick={onCancel} disabled={isBusy}>
                        Cancel
                    </Button>
                    <Button onClick={() => onConfirm(dontShowAgain)} disabled={isBusy}>
                        {isBusy ? <Progress.Dots /> : 'Confirm'}
                    </Button>
                </ActionsContainer>
            </Dialog.Actions>
        </StyledDialog>
    )
}

const StyledDialog = styled(Dialog)`
    width: 90vw;
    max-width: 460px;
`

const CheckboxContainer = styled.div`
    margin-top: 16px;
`

const ActionsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 28px;
`

export default TrendingConsentDialog
